import React from "react";
import client from "@culturehq/client";
import { Icon, Loader, Panel } from "@culturehq/components";
import { Trans } from "app/utils";
import { useFetch } from "app/hooks";

import ErrorBoundary from "components/common/ErrorBoundary";
import { Link } from "react-router-dom";
import PromptImage from "./PromptImage";

const DiscoverStories = ({ title = "Join other trends", icon = "book", currentStoryId }) => {
  const { fetching, json: { stories = [] } } = useFetch(
    () => client.getTrendingStoryQuestion({ answered: true }),
    []
  );

  return (
    <>
      {stories.length > 1 && (
        <div className="Discover-Stories">
          <Panel>
            <Panel.Heading>
              <Icon icon={icon} />
              <Trans>{title}</Trans>
            </Panel.Heading>
            <Panel.Body>
              <Loader loading={fetching}>
                <ErrorBoundary>
                  {stories.map(story => (
                    <div key={story.id}>
                      {(currentStoryId !== story.id) && (
                        <Link to={`/stories/trend/${story.id}`} key={story.id} className="Story--Link">
                          <PromptImage prompt={story} />
                          <div className="Story--Texts">
                            <span className="Story--Question">{story.question}</span>
                            <span className="Story--Number"><Trans>{story.answers} {story.isTrending && "new"} {story.answers === 1 ? "story" : "stories"}</Trans></span>
                          </div>
                        </Link>
                      )}
                    </div>
                  ))}
                </ErrorBoundary>
              </Loader>
            </Panel.Body>
          </Panel>
        </div>
      )}
    </>
  );
};

export default DiscoverStories;
